import { message } from "antd";
import { request } from "../utils";

export function getUserListAPI(params) {
  return request({
    url: "/admin/user/page",
    method: "GET",
    params: params,
  });
}
// 管理员相关
export function getManagerListAPI(params) {
  return request({
    url: "/admin/manager/page",
    method: "GET",
    params: params,
  });
}
export function changeEnableTypeAPI(params) {
  //管理员启用禁用
  return request({
    url: `/admin/manager/enable/${params.id}/${params.enable}`,
    method: "PUT",
  })
    .then((res) => {
      message.success("操作成功");
      console.log(res.data.message)
    })
    .catch((err) => {
      message.error(`操作失败`);
      console.log(err.message)
    });
}
export function changeRootTypeAPI(params) {
  //是否为超管,只传一个enable参数
  return request({
    url: `/adminmanager/update`,
    method: "PUT",
    data: params,
  });
}
export function deleteManagerAPI(managerId) {
  return request({
    url: `/admin/manager/delete/${managerId}`,
    method: "DELETE",
  })
    .then(() => {
      message.success("删除成功");
    })
    .catch(() => {
      message.error("删除失败");
    });
}
export function batchDeleteManagerAPI(data) {
  return request({
    url: "/admin/manager/delete/batch",
    method: "DELETE",
    data: data,
  })
    .then(() => {
      message.success("批量删除成功");
    })
    .catch(() => {
      message.error("批量删除失败");
    });
}
export function editManagerInfoAPI(params) {
  return request({
    url: "/admin/manager/update",
    method: "PUT",
    data: params,
  })
    .then(() => {
      message.success("修改成功");
    })
    .catch(() => {
      message.error("修改失败");
    });
}
export function newManagerAPI(data) {
  return request({
    url: "/admin/manager/add",
    method: "POST",
    data: data,
  })
    .then(() => {
      message.success("添加成功");
    })
    .catch(() => {
      message.error("添加失败");
    });
}
export function getManagerDetailAPI(managerId) {
  return request({
    url: `/admin/manager/detail/${managerId}`,
    method: "GET",
  });
}
export function updatePesonalAPI(data) {
  return request({
    url: "/admin/manager/update/self",
    method: "PUT",
    data: data,
  })
    .then((res) => {
      message.success("修改个人信息成功");
      console.log(res.data.message);
      return Promise.resolve(res);
    })
    .catch((err) => {
      message.error("修改个人信息失败");
      console.log(err.message);
    });
}
export function updatePasswordAPI(data) {
  return request({
    url: "/admin/manager/update/password",
    method: "PUT",
    data: data,
  })
    .then((res) => {
      message.success("修改密码成功");
      console.log(res.data.message);
    })
    .catch((err) => {
      message.error(`修改密码失败：${err.message}`);
      console.log(err.message);
    });
}
